export default `<div class="styles__CategoryList">
<div class="column">
   <div class="group">
         <h2 class="title">Shop by category</h2>
      <ul>
      <li><a href="/view/home/bedding/blankets-and-throws/" title="Blankets & Throws"><div class="item"><div class="item-label">Blankets &amp; Throws</div></div></a></li>
      <li><a href="/view/home/bedding/comforters/" title="Comforters"><div class="item"><div class="item-label">Comforters</div></div></a></li>
      <li><a href="/view/home/bedding/duvet-covers/" title="Duvet Covers"><div class="item"><div class="item-label">Duvet Covers</div></div></a></li>
      <li><a href="/view/home/bedding/pillowcases/" title="Pillowcases"><div class="item"><div class="item-label">Pillowcases</div></div></a></li>
      <li><a href="/view/home/bedding/pillows/" title="Pillows"><div class="item"><div class="item-label">Pillows</div></div></a></li>
      <li><a href="/view/home/bedding/shams/" title="Shams"><div class="item"><div class="item-label">Shams</div></div></a></li>
      <li><a href="/view/home/bedding/sheets/" title="Sheets"><div class="item"><div class="item-label">Sheets</div></div></a></li>
      </ul>
   </div>
</div>
</div>`